define('lq/licquidRuntimeMpa',[
    'underscore',
    'drops/action/action',
    'lq/runtimePiping',
    'lq/style',
    'lq/windowSize',
    'lq/navigatorMpa',
    'lq/services/mpa/serviceFactory',
    'lq/javascript/polyfill'
], function (_, Action, RuntimePiping, Style, windowSize, NavigatorMpa, serviceFactory) {

    var inIframe = function() {
        return window !== window.parent;
    };

    var LicquidRuntimeMpa = function () {
        if (window.cordova) {
            document.addEventListener('deviceready', function () {
                if (window.universalLinks) {
                    window.universalLinks.subscribe(null, function (eventData) {
                        window.location = eventData.url;
                    });
                }
            }, false);
        }
    };
    
    LicquidRuntimeMpa.prototype.start = function (setup) {
        Style.defaultStyles = setup.application.styles.defaultStyles;

        var $app = setup.$el;
        var $wrapper = $('<div class="licquid-action-wrapper" />')
            .appendTo($app);
        var $view = $('<div class="licquid-action-view" />')
            .appendTo($wrapper);

        this.globalPiping = RuntimePiping.createRoot(setup.application, $app, NavigatorMpa);
        this.globalPiping.navigator = new NavigatorMpa(this.globalPiping.url, setup.friendlyNames);
        this.globalPiping.errorHandler.addListener(this.handleError.bind(this));
        
        var action = new Action(setup.action.view, setup.application.options);
        action.backgroundDrops = setup.action.backgroundDrops;
        action.allLayouts = setup.action.allLayouts;
        action.defaultLayout = setup.action.defaultLayout;
        action.piping = this.globalPiping.createChildPiping(setup.action, setup.parameters, action, $wrapper, $view);

        // todo svb SPA temporary backwards compatibility
        action.services = _.map(setup.application.services.concat(setup.action.services), function (service) {
            return serviceFactory.createService(service, action);
        });

        // note: only the top level action should update the viewport
        action.createAndRenderDrops($('#viewport'));
        
        if (setup.application.embedded) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'LicquidLoaded'
            }), '*');
        }

        if (inIframe()) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'EmbeddedActionLoaded',
                sizeX: action.data.size.x,
                sizeY: action.data.size.y
            }), window.location.protocol + '//' + window.location.host);
        }

        if (inIframe()) {
            var receiveMessage = function (e) {
                if (e.source !== window.parent)
                    return;
                try {
                    var eventObj = JSON.parse(e.data);
                    if (!eventObj.eventName)
                        return;
                    action.triggerEvent(eventObj.eventName, eventObj.args[0]);
                } catch (err) {
                    //could not parse, ignore it
                }
            };

            window.addEventListener("message", receiveMessage, false);
        }

        windowSize.withOnChanged(function () {
            action.resize();
        });

        this.action = action;
    };

    LicquidRuntimeMpa.prototype.handleError = function (errorArgs) {
        if (this.action) this.action.error(errorArgs);
    };

    return LicquidRuntimeMpa;
});
